import { render, staticRenderFns } from "./GroupMemberActionsMenu.vue?vue&type=template&id=294a0ddc&"
import script from "./GroupMemberActionsMenu.vue?vue&type=script&lang=js&"
export * from "./GroupMemberActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports